import NavLinks from "./NavLinks";
import OpenSouceImage from "../images/opensource.png";

const Header = () => {
  return (
    <header className="header">
      <img className="logo" src={OpenSouceImage} alt="Michael Yeates' Logo" />
      <NavLinks />
    </header>
  );
};

export default Header;
